/**
 * Enter/exit VR. Renders nothing until the bridge reports a headset.
 */

import { useState } from 'react'
import { t } from '../../i18n/i18n'
import { useLang } from '../i18n/LanguageProvider'
import { useObservable, useTick } from '../state/useObservable'
import { vrBridge } from './vrBridge'

export function VrButton() {
  useLang()
  useTick(vrBridge.subscribe)
  const supported = useObservable(vrBridge.subscribe, () => vrBridge.supported)
  const [failed, setFailed] = useState(false)

  if (!supported) return null

  const label = failed ? t('xr.Unavailable') : vrBridge.active ? t('xr.ExitVr') : t('xr.EnterVr')

  return (
    <button
      className="btn primary vr-button"
      onClick={() => {
        if (vrBridge.active) {
          vrBridge.exit()
          return
        }
        void vrBridge.enter().catch(() => setFailed(true))
      }}
    >
      {label}
    </button>
  )
}
